// extracted by mini-css-extract-plugin
export default {"guestbook":"guestbook__guestbook--hR7qB","loadMoreBtnContainer":"guestbook__loadMoreBtnContainer--nj3NQ","hasNoEntries":"guestbook__hasNoEntries--pNmfD"};